module.exports = __webpack_public_path__ + "static/img/IMG_0456.4059fb0a.jpg";